import { getEstado } from "../lib/config";

export const EstadoBadge = ({ estado, className = "" }) => {
  const e = getEstado(estado);
  return (
    <span
      data-testid={`estado-badge-${e.key}`}
      className={`inline-flex items-center gap-1.5 text-[11px] font-bold uppercase px-2.5 py-0.5 rounded-full ${e.badge} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: e.dot }} />
      {e.label}
    </span>
  );
};
